<template>
    <v-flex>
        <a @click="resignCommunity()" data-qe-id="reassign-dialog_open_link"><u><i>{{appCommonConstants.RESIGN_FROM}} {{isRouteName}}</i></u></a>
        <v-flex
            class="banner_view__options__resign__popup"
            text-xs-left
            v-if="isResignConfPopupOpen">
            <v-btn
                class="banner_view__options__resign__popup__close"
                flat
                icon
                data-qe-id="close_dialog_btn"
                @click="closeResignConfPopup()"><i class="far fa-times-circle"></i></v-btn>
            <v-card class="panelBlock">
                <v-card-title class="banner_view__options__resign__popup__title" data-qe-id="Resign_Community_Name">
                    {{appCommonConstants.LEAVE_COMMUNITY_CONF_MESSAGE}} {{communityName}}?
                </v-card-title>
                <v-card-actions class="text-xs-center">
                    <v-layout
                        row
                        wrap
                        pa-4>
                        <v-flex xs12 text-xs-center>
                            <v-btn
                                class="primary_btn transparent theme--light"
                                flat
                                data-qe-id="cancel_dialog_btn"
                                @click="cancelCommunityRegistration()">
                                {{appCommonConstants.NO}}
                            </v-btn>
                            <v-btn
                                class="primary_btn theme--light"
                                dark
                                data-qe-id="save_dialog_btn"
                                @click="confirmCommunityResignation()">
                                {{appCommonConstants.YES}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-flex>
</template>

<script>
    import { mapActions, mapMutations, mapGetters } from "vuex";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { appCommonConstants, routerNames } from "../../appCommon.constants";
    import orderBy from "lodash/orderBy";

    export default {
        name: 'ResignCommunity',
        props: {
            communityName: {
                type: String,
                default: '',
            },
            communityIdPromise: {
                type: Promise,
                required: true,
            },
        },
        data: () => ({
            isResignConfPopupOpen: false,
            appCommonConstants,
            routerNames,
        }),
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                myQuickLinks: `tools/${storeGetters.myQuickLinks}`,
                categoryMaster: `tools/${storeGetters.categoryMaster}`,
            }),

            isRouteName() {
                return this.$route.name;
            },
        },
        methods: {
            ...mapActions({
                resignFromCommunity: `network/${storeAction.resignFromCommunity}`,
            }),
            ...mapMutations({
                removeResignedCommunityId: `chapter/${[storeMutation.removeResignedCommunityId]}`,
            }),
            confirmCommunityResignation() {
                this.communityIdPromise.then((communityId) => {
                    let communityData;
                    const communityName = this.$route.name;
                    const communitiesList = this.usersCommunitiesList;
                    this.resignFromCommunity(communityId).then((isResigned) => {
                        if (isResigned) {
                            if (communitiesList.some(o => o.communityType.toLowerCase() === communityName.toLowerCase() && o.communityId !== communityId)) {
                                const callBackCommunity = orderBy(communitiesList.filter(o => o.communityType.toLowerCase() === communityName.toLowerCase() && o.communityId !== communityId), (a => a.name.toLowerCase()), ["asc"])[0];
                                communityData = { communityId: callBackCommunity.communityId, name: callBackCommunity.name };
                            } else {
                                communityData = { communityId: null };
                            }
                            this.$emit('onResignSucess', communityData);
                            const quickLinkIndex = this.myQuickLinks.findIndex(item => item.communityId === communityId);
                            if (quickLinkIndex > -1) {
                                this.myQuickLinks.splice(quickLinkIndex, 1);
                            }
                            if (this.categoryMaster) {
                                this.categoryMaster.forEach((item) => {
                                    for (let i = 0; i < item.links.length; i += 1) {
                                        if (item.links[i].communityId === communityId) {
                                           const categoryMasterIndex = item.links.findIndex(CAIndex => CAIndex.communityId === communityId);
                                           item.links.splice(categoryMasterIndex, 1);
                                        }
                                    }
                                });
                            }
                        }
                    }).catch((err) => {
                        this.$emit('onResignFailure', err);
                    });
                });
                this.isResignConfPopupOpen = false;
            },
            cancelCommunityRegistration() {
                this.isResignConfPopupOpen = false;
            },
            resignCommunity() {
                this.isResignConfPopupOpen = !this.isResignConfPopupOpen;
            },
            closeResignConfPopup() {
                this.isResignConfPopupOpen = false;
            },
        },
    };
</script>

<style lang="scss" scoped>

</style>
